import React from "react"
import validateInput from "../../../view/shared/validations/validateShares"
import { WarningMessage } from "../../../view/shared/notifications/Notifications"
import { Trans, useLingui } from "@lingui/react"
import PropTypes from "prop-types"

import { Form, Container, FormGroup, Label, Input } from "reactstrap"
import { connect } from "react-redux"
import stellarProcessing from "../../../view/assets/stellar-animation.gif"
import { toast } from "react-toastify"
import { selectGroupWelfareBalance } from "../../../store/reducers/getVslaBalance"
import LastSharesSold from "../../reverseTransactions/LastSharesSold"
import { currentTransactionContext } from "../../../store/actions/transactionContext"
import { initiateTransaction } from "../../../store/reducers/transactions/actions"

import { selectCreatedVslaInfo } from "../../../store/reducers/getVslas"
import { setCurrentPage } from "../../../store/reducers/navigation"
import {
  arabicToInt,
  intToArabic,
} from "../../../view/shared/utilities/arabicNumParser"
import { t } from "@lingui/macro"
import styles from "./style.module.css"

const notify = (msg) => toast(msg)

const SellShares = (props) => {
  const { i18n } = useLingui()

  React.useEffect(() => {
    props.pushTransactionContext("Shares sold")
  }, [])

  const [state, setState] = React.useState({
    number_of_shares: "",
    errors: {},
    loading: false,
    omt_receipt_number: "",
  })

  const onChange = (e) => setState({ ...state, [e.target.name]: e.target.value })

  const isValid = () => {
    const { errors, isValid } = validateInput(state)

    if (!isValid) {
      setState({ ...state, errors })
    }
    return isValid
  }

  const onSubmit = (e) => {
    e.preventDefault()
    if (isValid()) {
      processTransaction(
        arabicToInt(state.number_of_shares),
        state.omt_receipt_number,
      )
      setState({ ...state, number_of_shares: "", omt_receipt_number: "" })
    }
  }

  const processTransaction = (number_of_shares, omt_receipt_number) => {
    const lang_code = i18n.locale

    const lang = {
      fr: {
        message: `Confirmer la saisie de ${state.number_of_shares} actions pour le membre`,
      },
      en: {
        message: `Confirm selling of ${state.number_of_shares} shares for member`,
      },
      sw: {
        message: `Thibitisha mwanachama anauza hisa ${state.number_of_shares}`,
      },
      ZARMA: {
        message: `Zarma for Confirm selling of ${state.number_of_shares} shares for member`,
      },
      HAOUSSA: {
        message: `Haoussa for Confirm selling of ${state.number_of_shares} shares for member`,
      },
      es: {
        message: `Confirmar venta de ${state.number_of_shares} acciones para miembro`,
      },
      lb: {
        message: `Confirm withdrawal of ${state.number_of_shares} savings for household`,
      },
      pt: {
        message: `Confirme a venda de ${state.number_of_shares} ações para o membro`,
      },
      ar: {
        message: `أكد سحب ${state.number_of_shares} من المدخرات للأسرة`,
      },
    }

    if (window.confirm(lang[lang_code].message)) {
      setState({ ...state, loading: true })
      const uuid = props.currentMember.pubkey
      const share_value = props.group?.cycle?.shareValue
      const amount = (number_of_shares * share_value).toString()
      const meetingId = props.ongoingMeeting?.id
        ? props.ongoingMeeting?.id
        : props.ongoingMeeting?.cacheId

      props.commitTransaction({
        uid: uuid,
        type: "SELL_SHARES",
        sharePrice: 1,
        amount: parseFloat(amount),
        metadata: {
          omtReceiptNumber: omt_receipt_number,
        },
        ...(props.currentMember?.id
          ? {
            member_id: props.currentMember?.id,
          }
          : {
            memberCacheId:
              props.currentMember?.cacheId || props.currentMember?.pubkey,
          }),
      })
      notify(<WarningMessage msg={"Processing Transaction"} />)
      props.setPage("group-memberList")
    } else {
      notify(<WarningMessage />)
    }
  }

  const redirectBack = () => {
    props.setPage("group-memberActions")
  }

  if (!state.loading) {
    return (
      <Container>
        <div>
          <h4 className={styles.header}>{props.currentMember?.full_name}</h4>
        </div>
        <div>
          <h4 className={styles.header}>
            <Trans id="Sell Shares">Sell Shares</Trans>
          </h4>
        </div>
        <div className={styles.info}>
          <p>
            <Trans id="Member's shares:">Member's shares:</Trans>{" "}
            {i18n.locale === "ar"
              ? intToArabic(
                parseFloat(
                  props.membersShares(props.currentMember?.pubkey),
                ).toFixed(2),
              )
              : parseFloat(props.membersShares(props.currentMember?.pubkey)).toFixed(
                2,
              )}
          </p>
        </div>
        <Form onSubmit={onSubmit}>
          <Container>
            <FormGroup>
              <span className={styles.errorMessage}>{state.errors.amount}</span>
              <Label className={styles.formLabel}>
                {t({ id: "Savings Withdrawal" })}
              </Label>
              <Input
                type="number"
                name="number_of_shares"
                placeholder={t({ id: "Number of shares" })}
                value={state.number_of_shares}
                onChange={onChange}
                className={styles.formInput}
              />
            </FormGroup>
            {["ar", "lb"].includes(i18n.locale) && (
              <FormGroup>
                <Label className={styles.formLabel}>
                  {t({ id: "OMT Receipt Number" })}
                </Label>
                <Input
                  type="text"
                  name="omt_receipt_number"
                  placeholder={t({ id: "Enter receipt number" })}
                  value={state.omt_receipt_number}
                  onChange={onChange}
                  className={styles.formInput}
                />
              </FormGroup>
            )}
            {parseFloat(
              parseFloat(props.membersShares(props.currentMember?.pubkey)),
            ) < parseFloat(state.number_of_shares) && (
                <span className={styles.errorMessage}>
                  <Trans id="sell.shares.error">
                    The number of shares you are trying to sell is more than the
                    members total shares
                  </Trans>
                </span>
              )}
            <FormGroup>
              <Input
                type="submit"
                value={t({ id: "Sell Shares" })}
                name="submit"
                className={`btn btn-primary ${styles.submitButton}`}
                disabled={
                  parseFloat(props.membersShares(props.currentMember?.pubkey)) <
                    parseFloat(state.number_of_shares)
                    ? true
                    : false
                }
              />
            </FormGroup>
          </Container>
        </Form>
        {props.isConnected && (
          <LastSharesSold
            offlineMeeting={props.offlineMeeting}
            redirectBack={redirectBack}
            reversal_details={{
              sourceFundType: "issuer",
              reversalTransactionType: "Shares sold reversed",
            }}
            transactions={props.transactions}
          />
        )}
      </Container>
    )
  }

  return (
    <div className={styles.spinnerContainer}>
      <img src={stellarProcessing} className={styles.spinner} alt="Stellar" />
    </div>
  )
}

SellShares.propTypes = {
  vsla: PropTypes.object,
  pushTransactionContext: PropTypes.func,
  currentMember: PropTypes.object,
  commitTransaction: PropTypes.func,
  ongoingMeeting: PropTypes.array,
  group: PropTypes.object,
  setPage: PropTypes.func,
  membersShares: PropTypes.func,
  isConnected: PropTypes.bool,
  offlineMeeting: PropTypes.object,
  transactions: PropTypes.array,
}

const mapStateToProps = (state) => {
  const { account, accountV2, loadedMember, vsla, group } = state

  const selectMemberShares = (pubkey) => {
    if (!pubkey) return 0

    let memberAccount = null

    // Priority 1: Check offline state using pubkey
    if (accountV2.offline?.members[pubkey]) {
      memberAccount = accountV2.offline.members[pubkey]
    } else {
      if (account.members[pubkey]) {
        memberAccount = account.members[pubkey]
      }
    }
    if (memberAccount && memberAccount.savings.balance > 0) {
      return parseFloat(memberAccount.savings.balance / group?.cycle?.shareValue)
    }

    return 0
  }
  const selectMemberReversableTransactions = (type) => {
    const memberPubkey = loadedMember?.pubkey
    if (!memberPubkey) {
      return []
    }
    else if (!accountV2.online?.transactions) {
      return []
    }
    return accountV2.online?.transactions?.[memberPubkey]?.filter(tx => tx.type === type) || []
  }
  return {
    isConnected: state.isConnected,
    vslaSummary: selectCreatedVslaInfo(state),
    ongoingMeeting: state.meeting?.ongoing,
    currentMember: loadedMember,
    welfareBalance: selectGroupWelfareBalance(state),
    membersShares: selectMemberShares,
    vsla: vsla,
    group: state.group,
    transactions: selectMemberReversableTransactions('SELL_SHARES'),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setPage: (page) => dispatch(setCurrentPage(page)),
    commitTransaction: (data, meeting) =>
      dispatch(initiateTransaction(data, meeting)),
    pushTransactionContext: (type) => dispatch(currentTransactionContext(type)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SellShares)
